
export const arrayPlanos = [
    { text: "Micro", _id: "micro" },
    { text: "Gestão", _id: "gestao" },
    { text: "Performance", _id: "performance" },
    { text: "Super", _id: "super" }
];




// WEBPACK FOOTER //
// ./src/domain/planos/planos.js